import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component,  Inject, Input, OnDestroy, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CarrentCardFilters } from '@app/models/carrent/CarrentCardFilters';
import { CarrentFilters } from '@app/models/carrent/CarrentFilters';
import { CarrentFiltersResponse } from '@app/models/offers/CarrentFiltersResponse';
import { CarrentFiltersService } from '@app/services/carrentfilters.service';
import { TrafficsService } from '@app/services/traffics.service';
import moment from 'moment';
import { Subject, takeUntil } from 'rxjs';
import { MEDIA_TOKEN } from '../../../../../../tockens';

@Component({
    selector: 'app-carrentfilter',
    templateUrl: './carrentfilter.component.html',
    styleUrls: ['./carrentfilter.component.scss'],
    standalone: false
})
export class CarrentfilterComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() realparams: CarrentCardFilters;
    @Input() reference: string;
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    showMore: boolean = false;
    smallVersion: boolean = true;
    media: string = 'lg';
    btntext: string = 'SUCHEN';
    start: string;
    end: string;
    filter: CarrentFilters;

    reisende = [
        {
            name: '1 Person',
            code: '1'
        },
        {
            name: '2 Personen',
            code: '2'
        },
        {
            name: '3 Personen',
            code: '3'
        },
        {
            name: '4 Personen',
            code: '4'
        },
        {
            name: '5 Personen',
            code: '5'
        },
        {
            name: '6 Personen',
            code: '6'
        },
        {
            name: '7 Personen',
            code: '7'
        },
        {
            name: '8 Personen',
            code: '8'
        }
    ];

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected carrentFilterService: CarrentFiltersService,
        protected trafficsService: TrafficsService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        this.getFilters();
        this.initFilterSub();
        this.initMedia();
    }

    initMedia(): void {
       if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initFilterSub(): void {
        this.carrentFilterService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: CarrentFilters) => {
            if (filter) {
                this.filter = JSON.parse(JSON.stringify(filter));
                this.cdr.detectChanges();
                this.initDate(filter);
            }
        });
    }

    getFilters() {
        this.trafficsService.request({}, 'offers/carrent/filters').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res: CarrentFiltersResponse) => {
            this.carrentFilterService.setExtras(res);
            this.initFilters();
        });
    }

    initDate(filter): void {
        // console.log(filter)
        if (Number(filter?.startNum) > 0 && Number(filter?.endNum) > 0) {
            this.start = moment().add(Number(filter.startNum), 'days').format('YYYY-MM-DD');
            this.end = moment().add(Number(filter.endNum), 'days').format('YYYY-MM-DD');
        } else if (moment(filter?.start).isValid() && moment(filter?.end).isValid()) {
            if (moment(filter.start).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
                this.start = moment().add(7, 'days').format('YYYY-MM-DD');
            } else {
                this.start = moment(filter.start).format('YYYY-MM-DD');
            }
            if (moment(filter.end).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
                this.end = moment().add(14, 'days').format('YYYY-MM-DD');
            } else if (moment(filter.end).format('YYYY-MM-DD') < moment(filter.start).format('YYYY-MM-DD')) {
                this.start = moment(filter.start).add(7, 'days').format('YYYY-MM-DD');
            } else {
                this.end = moment(filter.end).format('YYYY-MM-DD');
            }
        } else {
            this.start = moment().add(7, 'days').format('YYYY-MM-DD');
            this.end = moment().add(14, 'days').format('YYYY-MM-DD');
        }
        this.cdr.detectChanges();
    }

    gotoZiel(): void {
        this.smallVersion = true;
        this.carrentFilterService.setReference(this.reference);
        this.carrentFilterService.gotoUrl();
    }

    showMBMenu(): void {
        this.smallVersion = false;
    }

    openclosemore(): void {
        this.showMore = !this.showMore;
        if (!this.showMore) {
            // window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    initFilters(): void {
        if (this.realparams) {
            this.realparams.productType = 'carrent';
            this.carrentFilterService.onlySetRealParams(this.realparams);
        } else if (this.mode === 'home') {
            this.carrentFilterService.resetAllExtrasHome();
        } else {
            this.carrentFilterService.setOnlyNext();
        }
    }

    selectValue(ev): void {
        this.carrentFilterService.carrentdatevonf({ start: ev.start, end: ev.end }, this.mode === 'home');
    }

    selectAdultes(ev) {
        this.carrentFilterService.carrentreisendef(ev?.code, this.mode);
    }
}
